/**
 * Created by lu on 2018/4/16.
 */
var input = require('../../../view/form/Input');
var nb = require('../../../nb');
module.exports = nb.define({
    view: {
        'class': 'order-screen clearfix',
        $html: [{
            'class': 'screen-box',
            $html: [{
                'class': 'screen-title',
                $text: nb.bind('orderNumText')
            }, {
                $type: input,
                $model: 'orderNum'
            }]
        }, {
            'class': 'screen-box',
            $html: [{
                'class': 'screen-title',
                $text: nb.bind('productNameText')
            }, {
                $type: input,
                $model: 'productName'
            }]
        },
            {
                'class': 'screen-box',
                $html: [{
                    'class': 'screen-title',
                    $text: nb.bind('orderTime')
                }, {
                    'class': 'choose-date',
                    $type: require('../../../view/form/InputDate'),
                    $model: 'date1'
                },{
                    tag:'span',
                    $text:' -- '
                }, {
                    'class': 'choose-date',
                    $type: require('../../../view/form/InputDate'),
                    $model: 'date2'
                }]
            },
            {
                'class': 'btn-solid-gold btn-xs screen-order',
                $text: nb.bind('screenText')
            }]
    },
    method: {
        init: function () {

        },
        onModelReady: function () {
            $('.choose-date input').datetimepicker({
                format: 'YYYY-MM-DD',
                locale: 'zh-cn'
            });
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/order/view/OrderScreen.js
// module id = 675
// module chunks = 3